/* eslint-disable max-len */
import { useQuery } from '@tanstack/react-query';
// Services
import {
  getResourcesStaffList, getResourceConfiguration, getResourcesList, getOwnResource,
} from './resourceService';
// Constants
import { BU_QWERI, BU_ZOL, BU_BANZAI } from '../../constants';

/**
 * @description useQuery Hook to get the config of each resources.
 * @param {Object} options useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<Array<import('../types').ResourceConfiguration>, Error>}
 */
export const useResourcesStaffListQuery = (options) => useQuery({
  queryKey: ['resourcesConfigurationsList'],
  queryFn: () => getResourcesStaffList(),
  ...options,
});

/**
 * @description useQuery Hook to get a resource from its ID.
 * @param {Object} queryParams
 * @param {string} queryParams.resourceId
 * @param {Object} options useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<import('../types').ResourceConfiguration, Error>}
 */
export const useResourceQuery = (queryParams, options) => useQuery({
  queryKey: ['resource', queryParams],
  queryFn: () => getResourceConfiguration(queryParams),
  ...options,
});

/**
 * @description useQuery Hook to get resources list.
 * @param {Object} options useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<Array<import('../types').Resource>, Error>}
 */
export const useResourcesListQuery = (options) => useQuery({
  queryKey: ['resourcesList'],
  queryFn: () => getResourcesList(),
  placeholderData: (prev) => prev,
  select: (data) => {
    // @ts-ignore
    const groupedResources = data.reduce((acc, resource) => {
      (acc[resource.businessUnit] = acc[resource.businessUnit] || []).push(resource);
      return acc;
    }, {});
    return [BU_ZOL, BU_QWERI, BU_BANZAI].flatMap((bu) => groupedResources[bu] || []);
  },
  ...options,
});

/**
 * @description useQuery Hook to get connected user associated resource.
 * @param {Object} options useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<{data:import('../types').Resource}, Error>}
 */
export const useOwnResourceQuery = (options) => useQuery({
  queryKey: ['ownResource'],
  queryFn: () => getOwnResource(),
  placeholderData: (prev) => prev,
  ...options,
});
